import { useState } from "react";
import UserListado from "./UserListado";
import UserCrud from "./UserCrud";
import usePermissions from "../../../hook/usePermissions";
import Boton from "../../UI/Boton";
import { IconoMas } from "../../UI/Iconos";

export default function UserIndex({tabs}) {
    // RBAC-CUTOVER-07: Crear depende de users.create (backend ya lo exige en
    // users.routes.ts); Editar/Eliminar se gatean dentro de UserListado.js.
    const { hasPermission } = usePermissions();
    const [showUser, setShowUser] = useState(false);
    const [userData, setDataUser] = useState(false);
    const [usersRefreshKey, setUsersRefreshKey] = useState(0);
    
    const handleUser = () => {
        if (!showUser) {
            setDataUser(false);
        }
        setShowUser(!showUser);
    }

    const handleShowEdit = (user) => {
        setShowUser(!showUser);
        setDataUser(user)
    }

    return (
        <section>
            {hasPermission("users.create") && (
                <div className="d-flex justify-content-end mb-3">
                    <Boton variante="primario" icono={IconoMas} onClick={handleUser} data-testid="usuario-crear">
                        Crear Personal
                    </Boton>
                </div>
            )}

            <UserListado data={{
                tabs:tabs,
                handleShowEdit: handleShowEdit,
                refreshKey: usersRefreshKey
            }}/>

            <UserCrud 
                data={{
                    show: showUser,
                    handleClose: handleUser,
                    userData:userData,
                    onRoleChanged: (updatedUser) => {
                        setDataUser(updatedUser);
                        setUsersRefreshKey((key) => key + 1);
                    }
                }}
            />

        </section>        
    )
}
